<template>
    <div class="employee-certifications">
        <div class="container" v-if="certifications.length>0">
            <div>
                <span class="title">الشهادات</span>
                <span class="title-underline"></span>
            </div>

            <b-row >
                <b-col v-for="certificate in certifications" :key="certificate.id" cols="12" md="3">
                    <Certificate :certificate="certificate"></Certificate>
                </b-col>

            </b-row>

        </div>
    </div>
</template>
<script>
import Certificate from './Certificate.vue';

export default {
    name: 'EmployeeCertifications',
    components: { Certificate },
    props:{
        certifications:{
      type: Array,
      default: () => [],
    }},
}
</script>
<style lang="">

</style>
